import React, { useEffect, useState } from "react";
import { Clapperboard, Play, RefreshCw, Film, Trash2 } from "lucide-react";
import { T } from "./office";
import { req } from "./panels";

// Tab Reels di Hasil Kerja: daftar naskah animatic, tombol "Render reels", progres frame, dan pratinjau video hasil render.
const btn = (bg = T.accent, color = "#fff", disabled = false) => ({ display: "inline-flex", alignItems: "center", gap: 5, padding: "7px 11px", borderRadius: 99, border: `1px solid ${bg === "#fff" ? T.border : bg}`, background: bg, color, fontSize: 11.5, fontWeight: 800, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.55 : 1, fontFamily: T.font });
const WARNA = { siap: T.sub, berjalan: T.working, selesai: T.accent, gagal: "#dc2626" };
const LABEL = { siap: "Siap render", berjalan: "Merender...", selesai: "Selesai", gagal: "Gagal" };
const BASE = process.env.REACT_APP_BACKEND_URL;

function KartuNaskah({ n, token, onUbah }) {
  const [err, setErr] = useState("");
  const pct = n.total ? Math.round((n.frame / n.total) * 100) : 0;
  const sibuk = n.status === "berjalan";
  const render = async () => {
    setErr("");
    try { await req(`/animatic/render/${n.id}`, token, { method: "POST" }); onUbah(); } catch (e) { setErr(e.message); }
  };
  const hapus = async () => {
    if (!window.confirm(`Hapus naskah "${n.judul}" beserta videonya? Cache suara tetap disimpan.`)) return;
    setErr("");
    try { await req(`/animatic/naskah/${n.id}`, token, { method: "DELETE" }); onUbah(); } catch (e) { setErr(e.message); }
  };
  return (
    <div data-testid={`reels-kartu-${n.id}`} style={{ width: 300, background: "#fff", border: `1px solid ${T.border}`, borderRadius: 18, padding: 14, display: "flex", flexDirection: "column", gap: 10, fontFamily: T.font }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
        <div>
          <div style={{ fontWeight: 800, fontSize: 13, color: T.ink, lineHeight: 1.25 }}>{n.judul}</div>
          <div style={{ fontSize: 10.5, color: T.sub, fontWeight: 600, marginTop: 2 }}>{n.id} · {n.scenes} scene · kota {n.kota}</div>
        </div>
        <span data-testid={`reels-status-${n.id}`} style={{ fontSize: 10.5, fontWeight: 800, padding: "3px 8px", borderRadius: 99, background: WARNA[n.status], color: "#fff", whiteSpace: "nowrap" }}>{LABEL[n.status]}</span>
      </div>
      {n.video && !sibuk && (
        <video data-testid={`reels-video-${n.id}`} src={`${BASE}${n.video}`} controls playsInline style={{ width: "100%", aspectRatio: "9/16", maxHeight: 420, borderRadius: 12, background: "#0B1A5C", objectFit: "contain" }} />
      )}
      {sibuk && (
        <div data-testid={`reels-progres-${n.id}`}>
          <div style={{ height: 8, borderRadius: 99, background: T.panel2, overflow: "hidden" }}><div style={{ width: `${pct}%`, height: "100%", background: T.accent, transition: "width .6s" }} /></div>
          <div style={{ fontSize: 11, color: T.sub, fontWeight: 600, marginTop: 5 }}>{n.pesan} {n.total ? `· ${pct}%` : ""}</div>
        </div>
      )}
      {n.status === "gagal" && <div data-testid={`reels-gagal-${n.id}`} style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, wordBreak: "break-word" }}>{n.pesan}</div>}
      {err && <div style={{ fontSize: 11, color: "#dc2626", fontWeight: 600 }}>{err}</div>}
      <div style={{ display: "flex", gap: 6 }}>
        <button data-testid={`reels-render-${n.id}`} disabled={sibuk} onClick={render} style={btn(T.accent, "#fff", sibuk)}>{sibuk ? <RefreshCw size={13} className="jw-spin" /> : <Play size={13} />} {n.video ? "Render ulang" : "Render reels"}</button>
        {n.video && !sibuk && <a data-testid={`reels-unduh-${n.id}`} href={`${BASE}${n.video}`} download={`${n.id}.mp4`} style={{ ...btn("#fff", T.ink), textDecoration: "none" }}><Film size={13} /> Unduh</a>}
        {!sibuk && <button data-testid={`reels-hapus-${n.id}`} onClick={hapus} title="Hapus naskah & video" style={{ ...btn("#fff", "#dc2626"), marginLeft: "auto", padding: "7px 9px" }}><Trash2 size={13} /></button>}
      </div>
    </div>
  );
}

export function PanelReels({ token }) {
  const [daftar, setDaftar] = useState([]);
  const muat = () => req("/animatic/naskah", token).then(setDaftar).catch(() => {});
  useEffect(() => { muat(); const t = setInterval(muat, 3000); return () => clearInterval(t); }, [token]); // eslint-disable-line
  return (
    <div data-testid="panel-reels" style={{ display: "flex", flexWrap: "wrap", gap: 14, alignContent: "flex-start" }}>
      <style>{`@keyframes jw-spin{to{transform:rotate(360deg)}} .jw-spin{animation:jw-spin 1s linear infinite}`}</style>
      {daftar.length === 0 && <p data-testid="reels-kosong" style={{ color: T.sub, fontSize: 12.5, margin: 0, lineHeight: 1.6 }}><Clapperboard size={14} style={{ verticalAlign: -2 }} /> Belum ada naskah animatic di backend/animatic/naskah.</p>}
      {daftar.map(n => <KartuNaskah key={n.id} n={n} token={token} onUbah={muat} />)}
    </div>
  );
}
